/**
 * @generated SignedSource<<78173a19e4933214f24459e87ff5117e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GraphQLFacebookConfigInput = {
  id: string;
  token: string;
};
export type FacebookTab_updateFacebookClientTokenMutation$variables = {
  input: GraphQLFacebookConfigInput;
};
export type FacebookTab_updateFacebookClientTokenMutation$data = {
  readonly updateFacebookClientToken: {
    readonly " $fragmentSpreads": FragmentRefs<"FacebookTab_brand">;
  };
};
export type FacebookTab_updateFacebookClientTokenMutation = {
  response: FacebookTab_updateFacebookClientTokenMutation$data;
  variables: FacebookTab_updateFacebookClientTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FacebookTab_updateFacebookClientTokenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateFacebookClientToken",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FacebookTab_brand"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FacebookTab_updateFacebookClientTokenMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "updateFacebookClientToken",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLFacebookClientConfig",
            "kind": "LinkedField",
            "name": "facebookConfig",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "needsReauth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLFacebookPage",
                "kind": "LinkedField",
                "name": "facebookPages",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSelected",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5a3d16c7415fba0be4735c09f1b324f0",
    "id": null,
    "metadata": {},
    "name": "FacebookTab_updateFacebookClientTokenMutation",
    "operationKind": "mutation",
    "text": "mutation FacebookTab_updateFacebookClientTokenMutation(\n  $input: GraphQLFacebookConfigInput!\n) {\n  updateFacebookClientToken(input: $input) {\n    ...FacebookTab_brand\n    id\n  }\n}\n\nfragment FacebookTab_brand on BrandType {\n  id\n  facebookConfig {\n    id\n    needsReauth\n    facebookPages {\n      id\n      name\n      isSelected\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ed63df3cd290e65a5649146e0fdcecc";

export default node;
